import React, { useState } from "react";
import "@/App.css";
import { Phone, Mail, Star, Users, Award, CheckCircle, Sparkles, Shield, Leaf, ExternalLink, Globe } from "lucide-react";

// Images from the original site
const IMAGES = {
  logo: "https://customer-assets.emergentagent.com/job_54af2999-c2c5-4ef9-8a06-7591de08ffb9/artifacts/qfk6v7tr_IMG_3232.jpeg",
  heroTeam: "https://images.pexels.com/photos/6197116/pexels-photo-6197116.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  commercial: "https://images.pexels.com/photos/36631699/pexels-photo-36631699.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  specialized: "https://images.unsplash.com/photo-1740657254989-42fe9c3b8cce?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxjbGVhbmluZyUyMHNlcnZpY2V8ZW58MHx8fHwxNzc1NTcwNDQwfDA&ixlib=rb-4.1.0&q=85",
  carpet: "https://customer-assets.emergentagent.com/job_clean-services-26/artifacts/zxsz9r79_IMG_0737.jpeg",
  floor: "https://images.pexels.com/photos/36631699/pexels-photo-36631699.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  furniture: "https://images.unsplash.com/photo-1686178827149-6d55c72d81df?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwyfHxjbGVhbmluZyUyMHNlcnZpY2V8ZW58MHx8fHwxNzc1NTcwNDQwfDA&ixlib=rb-4.1.0&q=85",
  equipment: "https://images.pexels.com/photos/34516664/pexels-photo-34516664.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  ajAcademies: "https://customer-assets.emergentagent.com/job_clean-services-26/artifacts/ry6mvfuq_IMG_3876.jpeg",
  ajAcademiesTeam: "https://customer-assets.emergentagent.com/job_website-deploy-7/artifacts/s22ykq1e_3CA6D605-4E1A-4F12-98DD-9D7AC24D331C.png"
};

// Translations
const translations = {
  en: {
    // Navigation
    tagline: "Staffing Agency & Professional Cleaning Services",
    
    // Hero
    heroSubtitle: "MONARCA Gestion Inc. delivers premium cleaning solutions and professional staffing services tailored to your business needs. Trust our expert team for impeccable results.",
    staffingAgency: "Staffing Agency",
    contactUs: "Contact Us",
    happyClients: "Happy Clients",
    yearsExperience: "Years Experience",
    satisfaction: "Satisfaction",
    premium: "Premium",
    qualityService: "Quality Service",
    
    // Services
    ourServices: "Our Services",
    comprehensiveSolutions: "Comprehensive Cleaning Solutions",
    commercialCleaning: "Commercial Cleaning",
    commercialDesc: "Professional office and building maintenance services designed to keep your workspace pristine and productive.",
    commercialFeatures: ["Office Buildings", "Retail Spaces", "Medical Facilities", "Educational Institutions"],
    specializedServices: "Specialized Services",
    specializedDesc: "Expert deep cleaning and specialized solutions for unique cleaning challenges and requirements.",
    specializedFeatures: ["Deep Cleaning", "Move-In/Move-Out", "Post-Construction", "Carpet & Upholstery"],
    carpetCleaning: "Carpet Cleaning",
    carpetDesc: "Professional carpet cleaning services using advanced equipment and eco-friendly solutions for deep stain removal and sanitization.",
    carpetFeatures: ["Deep Steam Cleaning", "Stain Removal", "Odor Elimination", "Fast Drying Technology"],
    floorWaxing: "Floor Waxing & Polishing",
    floorDesc: "Expert floor waxing and polishing services to restore shine and protect your floors for long-lasting beauty.",
    floorFeatures: ["Floor Stripping", "Professional Waxing", "High-Gloss Polishing", "Floor Protection"],
    professionalTeam: "Professional Team",
    professionalTeamDesc: "Trained and certified cleaning experts",
    qualityGuaranteed: "Quality Guaranteed",
    qualityGuaranteedDesc: "100% satisfaction or we return",
    ecoFriendly: "Eco-Friendly",
    ecoFriendlyDesc: "Safe products for your environment",
    
    // Gallery
    ourWork: "Our Work",
    seeTheDifference: "See the MONARCA difference",
    professionalEquipment: "Professional Equipment",
    floorCleaningGallery: "Floor Cleaning",
    furnitureCare: "Furniture Care",
    professionalTeamGallery: "Professional Team",
    cleanOfficeSpace: "Clean Office Space",
    galleryNote: "Every project showcases our commitment to excellence and attention to detail",
    
    // Testimonials
    clientTestimonials: "Client Testimonials",
    whatClientsSay: "What our clients say about us",
    testimonial1: "Exceptional service! MONARCA transformed our office space. The team is professional, thorough, and always on time. Highly recommended!",
    testimonial2: "We've been using MONARCA for our medical facility for over a year. Their attention to detail and understanding of sanitation standards is impressive.",
    testimonial3: "The best cleaning service we've ever worked with. They handle our multiple retail locations with efficiency and consistency. True professionals!",
    joinSatisfiedClients: "Join Our Satisfied Clients",
    experienceDifference: "Experience the MONARCA difference today",
    clientRetention: "Client Retention",
    averageRating: "Average Rating",
    projectsCompleted: "Projects Completed",
    
    // Community
    communityTagline: "Proud to support our local community",
    communityInvolvement: "Community Involvement",
    proudSponsor: "Proud Sponsor of",
    visitInstagram: "Visit Their Instagram",
    youthSoccerSupport: "Supporting Youth Soccer",
    
    // Contact
    getInTouch: "Get in Touch",
    contactSubtitle: "Contact us for a free quote",
    contactInfo: "Contact Information",
    president: "President",
    directorOps: "Director of Operations",
    supervisor: "Supervisor",
    
    // Footer
    madeWith: "Made with Emergent"
  },
  fr: {
    // Navigation
    tagline: "Agence de Placement & Services de Nettoyage Professionnels",
    
    // Hero
    heroSubtitle: "MONARCA Gestion Inc. offre des solutions de nettoyage haut de gamme et des services de placement professionnels adaptés aux besoins de votre entreprise. Faites confiance à notre équipe d'experts pour des résultats impeccables.",
    staffingAgency: "Agence de Placement",
    contactUs: "Contactez-nous",
    happyClients: "Clients Satisfaits",
    yearsExperience: "Années d'Expérience",
    satisfaction: "Satisfaction",
    premium: "Premium",
    qualityService: "Service de Qualité",
    
    // Services
    ourServices: "Nos Services",
    comprehensiveSolutions: "Solutions de Nettoyage Complètes",
    commercialCleaning: "Nettoyage Commercial",
    commercialDesc: "Services professionnels d'entretien de bureaux et de bâtiments conçus pour garder votre espace de travail impeccable et productif.",
    commercialFeatures: ["Immeubles de Bureaux", "Espaces Commerciaux", "Établissements Médicaux", "Institutions Éducatives"],
    specializedServices: "Services Spécialisés",
    specializedDesc: "Nettoyage en profondeur expert et solutions spécialisées pour des défis de nettoyage uniques.",
    specializedFeatures: ["Nettoyage en Profondeur", "Déménagement", "Post-Construction", "Tapis & Meubles"],
    carpetCleaning: "Nettoyage de Tapis",
    carpetDesc: "Services professionnels de nettoyage de tapis utilisant des équipements avancés et des solutions écologiques pour l'élimination des taches et la désinfection.",
    carpetFeatures: ["Nettoyage Vapeur", "Élimination des Taches", "Élimination des Odeurs", "Séchage Rapide"],
    floorWaxing: "Cirage & Polissage de Sols",
    floorDesc: "Services experts de cirage et polissage de sols pour restaurer la brillance et protéger vos planchers.",
    floorFeatures: ["Décapage de Sols", "Cirage Professionnel", "Polissage Haute Brillance", "Protection des Sols"],
    professionalTeam: "Équipe Professionnelle",
    professionalTeamDesc: "Experts en nettoyage formés et certifiés",
    qualityGuaranteed: "Qualité Garantie",
    qualityGuaranteedDesc: "100% satisfaction ou nous revenons",
    ecoFriendly: "Écologique",
    ecoFriendlyDesc: "Produits sûrs pour votre environnement",
    
    // Gallery
    ourWork: "Notre Travail",
    seeTheDifference: "Découvrez la différence MONARCA",
    professionalEquipment: "Équipement Professionnel",
    floorCleaningGallery: "Nettoyage de Sols",
    furnitureCare: "Entretien des Meubles",
    professionalTeamGallery: "Équipe Professionnelle",
    cleanOfficeSpace: "Bureau Propre",
    galleryNote: "Chaque projet démontre notre engagement envers l'excellence et le souci du détail",
    
    // Testimonials
    clientTestimonials: "Témoignages Clients",
    whatClientsSay: "Ce que nos clients disent de nous",
    testimonial1: "Service exceptionnel! MONARCA a transformé notre espace de bureau. L'équipe est professionnelle, minutieuse et toujours à l'heure. Hautement recommandé!",
    testimonial2: "Nous utilisons MONARCA pour notre établissement médical depuis plus d'un an. Leur attention aux détails et leur compréhension des normes sanitaires sont impressionnantes.",
    testimonial3: "Le meilleur service de nettoyage avec lequel nous ayons travaillé. Ils gèrent nos multiples emplacements commerciaux avec efficacité et constance. De vrais professionnels!",
    joinSatisfiedClients: "Rejoignez Nos Clients Satisfaits",
    experienceDifference: "Découvrez la différence MONARCA aujourd'hui",
    clientRetention: "Fidélisation Client",
    averageRating: "Note Moyenne",
    projectsCompleted: "Projets Réalisés",
    
    // Community
    communityTagline: "Fiers de soutenir notre communauté locale",
    communityInvolvement: "Implication Communautaire",
    proudSponsor: "Fier Commanditaire de",
    visitInstagram: "Visitez leur Instagram",
    youthSoccerSupport: "Soutien au Soccer Jeunesse",
    
    // Contact
    getInTouch: "Contactez-nous",
    contactSubtitle: "Demandez une soumission gratuite",
    contactInfo: "Informations de Contact",
    president: "Présidente",
    directorOps: "Directeur des Opérations",
    supervisor: "Superviseure",
    
    // Footer
    madeWith: "Créé avec Emergent"
  },
  es: {
    // Navigation
    tagline: "Agencia de Personal & Servicios de Limpieza Profesionales",
    
    // Hero
    heroSubtitle: "MONARCA Gestion Inc. ofrece soluciones de limpieza premium y servicios profesionales de personal adaptados a las necesidades de su negocio. Confíe en nuestro equipo de expertos para resultados impecables.",
    staffingAgency: "Agencia de Personal",
    contactUs: "Contáctenos",
    happyClients: "Clientes Felices",
    yearsExperience: "Años de Experiencia",
    satisfaction: "Satisfacción",
    premium: "Premium",
    qualityService: "Servicio de Calidad",
    
    // Services
    ourServices: "Nuestros Servicios",
    comprehensiveSolutions: "Soluciones de Limpieza Integrales",
    commercialCleaning: "Limpieza Comercial",
    commercialDesc: "Servicios profesionales de mantenimiento de oficinas y edificios diseñados para mantener su espacio de trabajo impecable y productivo.",
    commercialFeatures: ["Edificios de Oficinas", "Espacios Comerciales", "Instalaciones Médicas", "Instituciones Educativas"],
    specializedServices: "Servicios Especializados",
    specializedDesc: "Limpieza profunda experta y soluciones especializadas para desafíos de limpieza únicos.",
    specializedFeatures: ["Limpieza Profunda", "Mudanzas", "Post-Construcción", "Alfombras y Tapicería"],
    carpetCleaning: "Limpieza de Alfombras",
    carpetDesc: "Servicios profesionales de limpieza de alfombras utilizando equipos avanzados y soluciones ecológicas para eliminación de manchas y desinfección.",
    carpetFeatures: ["Limpieza a Vapor", "Eliminación de Manchas", "Eliminación de Olores", "Secado Rápido"],
    floorWaxing: "Encerado y Pulido de Pisos",
    floorDesc: "Servicios expertos de encerado y pulido de pisos para restaurar el brillo y proteger sus suelos.",
    floorFeatures: ["Decapado de Pisos", "Encerado Profesional", "Pulido de Alto Brillo", "Protección de Pisos"],
    professionalTeam: "Equipo Profesional",
    professionalTeamDesc: "Expertos en limpieza capacitados y certificados",
    qualityGuaranteed: "Calidad Garantizada",
    qualityGuaranteedDesc: "100% satisfacción o regresamos",
    ecoFriendly: "Ecológico",
    ecoFriendlyDesc: "Productos seguros para su ambiente",
    
    // Gallery
    ourWork: "Nuestro Trabajo",
    seeTheDifference: "Vea la diferencia MONARCA",
    professionalEquipment: "Equipo Profesional",
    floorCleaningGallery: "Limpieza de Pisos",
    furnitureCare: "Cuidado de Muebles",
    professionalTeamGallery: "Equipo Profesional",
    cleanOfficeSpace: "Oficina Limpia",
    galleryNote: "Cada proyecto demuestra nuestro compromiso con la excelencia y atención al detalle",
    
    // Testimonials
    clientTestimonials: "Testimonios de Clientes",
    whatClientsSay: "Lo que dicen nuestros clientes",
    testimonial1: "¡Servicio excepcional! MONARCA transformó nuestro espacio de oficina. El equipo es profesional, minucioso y siempre puntual. ¡Altamente recomendado!",
    testimonial2: "Hemos utilizado MONARCA para nuestra instalación médica durante más de un año. Su atención al detalle y comprensión de los estándares sanitarios es impresionante.",
    testimonial3: "El mejor servicio de limpieza con el que hemos trabajado. Manejan nuestras múltiples ubicaciones comerciales con eficiencia y consistencia. ¡Verdaderos profesionales!",
    joinSatisfiedClients: "Únase a Nuestros Clientes Satisfechos",
    experienceDifference: "Experimente la diferencia MONARCA hoy",
    clientRetention: "Retención de Clientes",
    averageRating: "Calificación Promedio",
    projectsCompleted: "Proyectos Completados",
    
    // Community
    communityTagline: "Orgullosos de apoyar a nuestra comunidad local",
    communityInvolvement: "Participación Comunitaria",
    proudSponsor: "Orgulloso Patrocinador de",
    visitInstagram: "Visite su Instagram",
    youthSoccerSupport: "Apoyando el Fútbol Juvenil",
    
    // Contact
    getInTouch: "Contáctenos",
    contactSubtitle: "Solicite una cotización gratuita",
    contactInfo: "Información de Contacto",
    president: "Presidenta",
    directorOps: "Director de Operaciones",
    supervisor: "Supervisora",
    
    // Footer
    madeWith: "Hecho con Emergent"
  }
};

// Team contacts
const teamContacts = [
  { name: "Judith Espinal", roleKey: "president", phone: "(438) 820-5864" },
  { name: "Kewin Dejala", roleKey: "directorOps", phone: "(514) 291-9450" },
  { name: "Tara Grant-Sarmanoukian", roleKey: "supervisor", phone: null }
];

// Gallery images
const galleryKeys = [
  { src: IMAGES.equipment, titleKey: "professionalEquipment" },
  { src: IMAGES.specialized, titleKey: "floorCleaningGallery" },
  { src: IMAGES.furniture, titleKey: "furnitureCare" },
  { src: IMAGES.heroTeam, titleKey: "professionalTeamGallery" },
  { src: IMAGES.commercial, titleKey: "cleanOfficeSpace" }
];

function App() {
  const [language, setLanguage] = useState('en');
  const t = translations[language];

  // Services data with translations
  const services = [
    {
      title: t.commercialCleaning,
      description: t.commercialDesc,
      image: IMAGES.commercial,
      features: t.commercialFeatures
    },
    {
      title: t.specializedServices,
      description: t.specializedDesc,
      image: IMAGES.specialized,
      features: t.specializedFeatures
    },
    {
      title: t.carpetCleaning,
      description: t.carpetDesc,
      image: IMAGES.carpet,
      features: t.carpetFeatures
    },
    {
      title: t.floorWaxing,
      description: t.floorDesc,
      image: IMAGES.floor,
      features: t.floorFeatures
    }
  ];

  // Testimonials data
  const testimonials = [
    { quote: t.testimonial1, name: "Marie Dubois", company: "TechCorp Inc." },
    { quote: t.testimonial2, name: "Carlos Rodriguez", company: "Medical Plaza" },
    { quote: t.testimonial3, name: "Sophie Martin", company: "Retail Solutions" }
  ];

  return (
    <div className="app" data-testid="monarca-app">
      {/* Navigation */}
      <nav className="navbar" data-testid="navbar">
        <div className="nav-container">
          <div className="nav-brand">
            <img src={IMAGES.logo} alt="MONARCA Gestion Inc." className="nav-logo" />
            <span className="nav-title">MONARCA</span>
          </div>
          <div className="nav-right">
            <div className="nav-tagline">{t.tagline}</div>
            <div className="language-selector" data-testid="language-selector">
              <Globe className="globe-icon" />
              <select 
                value={language} 
                onChange={(e) => setLanguage(e.target.value)}
                className="language-select"
                data-testid="language-select"
              >
                <option value="en">English</option>
                <option value="fr">Français</option>
                <option value="es">Español</option>
              </select>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="hero" data-testid="hero-section">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1 className="hero-title">MONARCA Gestion Inc.</h1>
          <p className="hero-subtitle">{t.heroSubtitle}</p>
          <div className="hero-badges">
            <span className="hero-badge">{t.staffingAgency}</span>
          </div>
          <a href="#contact" className="hero-cta" data-testid="hero-cta">{t.contactUs}</a>
        </div>
        
        {/* Stats */}
        <div className="hero-stats" data-testid="hero-stats">
          <div className="stat-item">
            <Users className="stat-icon" />
            <span className="stat-number">500+</span>
            <span className="stat-label">{t.happyClients}</span>
          </div>
          <div className="stat-item">
            <Award className="stat-icon" />
            <span className="stat-number">10+</span>
            <span className="stat-label">{t.yearsExperience}</span>
          </div>
          <div className="stat-item">
            <CheckCircle className="stat-icon" />
            <span className="stat-number">100%</span>
            <span className="stat-label">{t.satisfaction}</span>
          </div>
        </div>
      </section>

      {/* Hero Image Section */}
      <section className="hero-image-section">
        <div className="hero-image-container">
          <img src={IMAGES.heroTeam} alt="Professional Cleaning Team" className="hero-main-image" />
          <div className="hero-image-badge">
            <Sparkles className="badge-icon" />
            <span>{t.premium}</span>
            <span className="badge-sub">{t.qualityService}</span>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="services-section" id="services" data-testid="services-section">
        <div className="section-container">
          <h2 className="section-title">{t.ourServices}</h2>
          <p className="section-subtitle">{t.comprehensiveSolutions}</p>
          
          <div className="services-grid">
            {services.map((service, index) => (
              <div key={index} className="service-card" data-testid={`service-card-${index}`}>
                <div className="service-image-container">
                  <img src={service.image} alt={service.title} className="service-image" />
                </div>
                <div className="service-content">
                  <h3 className="service-title">{service.title}</h3>
                  <p className="service-description">{service.description}</p>
                  <ul className="service-features">
                    {service.features.map((feature, idx) => (
                      <li key={idx} className="service-feature">
                        <CheckCircle className="feature-icon" />
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>

          {/* Service Highlights */}
          <div className="service-highlights">
            <div className="highlight-item">
              <Shield className="highlight-icon" />
              <h4>{t.professionalTeam}</h4>
              <p>{t.professionalTeamDesc}</p>
            </div>
            <div className="highlight-item">
              <Star className="highlight-icon" />
              <h4>{t.qualityGuaranteed}</h4>
              <p>{t.qualityGuaranteedDesc}</p>
            </div>
            <div className="highlight-item">
              <Leaf className="highlight-icon" />
              <h4>{t.ecoFriendly}</h4>
              <p>{t.ecoFriendlyDesc}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section className="gallery-section" id="gallery" data-testid="gallery-section">
        <div className="section-container">
          <h2 className="section-title">{t.ourWork}</h2>
          <p className="section-subtitle">{t.seeTheDifference}</p>
          
          <div className="gallery-grid">
            {galleryKeys.map((item, index) => (
              <div key={index} className="gallery-item" data-testid={`gallery-item-${index}`}>
                <img src={item.src} alt={t[item.titleKey]} className="gallery-image" />
                <div className="gallery-overlay">
                  <h4>{t[item.titleKey]}</h4>
                </div>
              </div>
            ))}
          </div>
          <p className="gallery-note">{t.galleryNote}</p>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="testimonials-section" id="testimonials" data-testid="testimonials-section">
        <div className="section-container">
          <h2 className="section-title">{t.clientTestimonials}</h2>
          <p className="section-subtitle">{t.whatClientsSay}</p>
          
          <div className="testimonials-grid">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="testimonial-card" data-testid={`testimonial-${index}`}>
                <div className="testimonial-stars">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} className="star-icon filled" />
                  ))}
                </div>
                <p className="testimonial-quote">"{testimonial.quote}"</p>
                <div className="testimonial-author">
                  <span className="author-name">{testimonial.name}</span>
                  <span className="author-company">{testimonial.company}</span>
                </div>
              </div>
            ))}
          </div>

          {/* Client Stats */}
          <div className="client-stats">
            <h3>{t.joinSatisfiedClients}</h3>
            <p>{t.experienceDifference}</p>
            <div className="client-stats-grid">
              <div className="client-stat">
                <span className="client-stat-number">98%</span>
                <span className="client-stat-label">{t.clientRetention}</span>
              </div>
              <div className="client-stat">
                <span className="client-stat-number">5.0</span>
                <span className="client-stat-label">{t.averageRating}</span>
              </div>
              <div className="client-stat">
                <span className="client-stat-number">500+</span>
                <span className="client-stat-label">{t.projectsCompleted}</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Community Section */}
      <section className="community-section" data-testid="community-section">
        <div className="section-container">
          <p className="community-tagline">{t.communityTagline}</p>
          <h2 className="section-title">{t.communityInvolvement}</h2>
          
          <div className="sponsor-card">
            <h3>{t.proudSponsor}</h3>
            <div className="sponsor-content">
              <img src={IMAGES.ajAcademies} alt="AJ Academies Logo" className="sponsor-logo" />
              <div className="sponsor-info">
                <h4>AJ ACADEMIES</h4>
                <span>Est. 2020</span>
                <a 
                  href="https://www.instagram.com/ajacademies?igsh=aGdmdGhkOWhmd2E5" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="sponsor-link"
                  data-testid="aj-academies-link"
                >
                  <ExternalLink className="link-icon" />
                  {t.visitInstagram}
                </a>
              </div>
            </div>
          </div>

          {/* Team Photo */}
          <div className="team-photo-section" data-testid="team-photo-section">
            <h3 className="team-photo-title">{t.youthSoccerSupport}</h3>
            <div className="team-photo-container">
              <img 
                src={IMAGES.ajAcademiesTeam} 
                alt="AJ Academies Soccer Team sponsored by MONARCA" 
                className="team-photo"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="contact-section" id="contact" data-testid="contact-section">
        <div className="section-container">
          <h2 className="section-title">{t.getInTouch}</h2>
          <p className="section-subtitle">{t.contactSubtitle}</p>
          
          <div className="contact-content">
            <div className="contact-info-card">
              <h3>{t.contactInfo}</h3>
              
              <div className="contact-team">
                {teamContacts.map((contact, index) => (
                  <div key={index} className="team-contact" data-testid={`team-contact-${index}`}>
                    <h4>{contact.name}</h4>
                    <span className="contact-role">{t[contact.roleKey]}</span>
                    {contact.phone && (
                      <a href={`tel:${contact.phone}`} className="contact-phone">
                        <Phone className="contact-icon" />
                        {contact.phone}
                      </a>
                    )}
                  </div>
                ))}
              </div>

              <div className="contact-email" data-testid="contact-email">
                <Mail className="contact-icon" />
                <a href="mailto:Monarcagestion@gmail.com">Monarcagestion@gmail.com</a>
              </div>

              <div className="contact-logo">
                <img src={IMAGES.logo} alt="MONARCA Gestion Inc." />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer" data-testid="footer">
        <div className="footer-content">
          <a href="https://app.emergent.sh/?utm_source=emergent-badge" target="_blank" rel="noopener noreferrer" className="emergent-badge">
            {t.madeWith}
          </a>
        </div>
      </footer>
    </div>
  );
}

export default App;
